import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DragSourceMonitor, useDrag } from 'react-dnd';
import { setDraggingProps } from '../../stores/actions/user-interface';
import { DragItem } from '../../stores/reducers/user-interface';

const useDragItem = (dragItemData: DragItem, dragEnabled: boolean = true) => {
	const {
		type,
		id,
		name,
		template,
		provider,
	} = dragItemData;
	const dispatch = useDispatch();

	const [{ isDragging }, dragRef, dragPreview] = useDrag(() => ({
		type,
		item: {
			id,
			type,
			name,
			template,
			provider,
		},
		canDrag: () => dragEnabled,
		collect: (monitor: DragSourceMonitor) => ({
			isDragging: !!monitor.isDragging(),
		}),
		end: () => dispatch(setDraggingProps(null)),
	}), [type, id, dragEnabled]);

	useEffect(() => {
		if (isDragging) {
			dispatch(setDraggingProps({
				globalIsDragging: true,
				idOfDragging: id,
				typeOfDragging: type,
			}));
		}
	}, [isDragging]);

	return {
		dragRef,
		isDragging,
		dragPreview
	};
};

export default useDragItem;
